var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V28C36 32.4183 32.4183 36 28 36H8C3.58172 36 0 32.4183 0 28V8Z",
    fill: "#5062F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7879 8.18182C12.0349 8.18182 8.18182 12.0349 8.18182 16.7879C8.18182 21.5409 12.0349 25.3939 16.7879 25.3939C19.1099 25.3939 21.2172 24.4743 22.7653 22.9794C22.7954 22.9396 22.8286 22.9013 22.865 22.865C22.9013 22.8286 22.9396 22.7954 22.9794 22.7653C24.4743 21.2172 25.3939 19.1099 25.3939 16.7879C25.3939 12.0349 21.5409 8.18182 16.7879 8.18182ZM25.1486 23.6058C26.6658 21.7475 27.5758 19.374 27.5758 16.7879C27.5758 10.8299 22.7459 6 16.7879 6C10.8299 6 6 10.8299 6 16.7879C6 22.7459 10.8299 27.5758 16.7879 27.5758C19.374 27.5758 21.7475 26.6658 23.6058 25.1486L28.1377 29.6805C28.5637 30.1065 29.2545 30.1065 29.6805 29.6805C30.1065 29.2545 30.1065 28.5637 29.6805 28.1377L25.1486 23.6058Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchHeader);
export default __webpack_public_path__ + "static/media/searchHeader.67f71be2691309fe2af89363de41c6a6.svg";
export { ForwardRef as ReactComponent };